import React, { Component } from 'react';
import MaterialTable from 'material-table';
import Paper from '@material-ui/core/Paper';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import { toast } from 'react-toastify';

import {
    getDistributorUser,
    updateDistributorUser,
    deleteDistributorUser
} from '../../../actions/Distributor';

class ListDistributor extends Component{
    componentDidMount(){
        this.props.getDistributorUser();
    }
    navigateToDistributorUser = (url) => {
        this.props.history.push(url);
    }
    render(){
        let {
            distributorUserColumns,
            distributorUserInformations,
            listDistributorUserLoaderStatus
        } = this.props.distributorState;

        let{
            menuItems
        } = this.props.sidebarState;
        return(
            <div className = "container mt-3 mb-3">
                <Paper>
                    <div className = "d-flex">
                        <div className = "d-flex flex-wrap align-content-center mr-auto">
                            <h4 className = "mt-3 ml-2 text-uppercase">User List</h4>
                        </div>
                        <div className = "d-flex flex-wrap align-content-center">
                        <Button 
                            variant="contained" 
                            color="default"
                            className = "mr-3"
                            onClick = {() => this.props.history.push(menuItems['distributor_user_upload'].urlpattern)}
                        >
                            <i className="material-icons" style = {{paddingRight : "0.5rem"}}>
                                cloud_upload
                            </i>
                            Upload Distributor Users
                        </Button>
                            <Button 
                                variant="contained" 
                                color="primary"
                                onClick = {() => this.navigateToDistributorUser(menuItems['distributor_user_create'].urlpattern)}
                                className = "mr-2"
                            >
                                <i className="material-icons" style = {{paddingRight : "0.5rem"}}>
                                    add_circle_outline
                                </i>
                                Add User
                            </Button>
                        </div>
                    </div>
                    {
                        listDistributorUserLoaderStatus ? 
                        <div style = {{height : "30rem"}} className = "d-flex justify-content-center align-items-center">
                            <CircularProgress color = "primary" />
                        </div>
                         :
                        <MaterialTable
                            localization={{
                                // header: {
                                //     actions: 'Action'
                                // }
                                body: {
                                    editRow: {
                                        deleteText: 'Are you sure you want to delete this user?'
                                    },
                                    editTooltip : "Edit",
                                    deleteTooltip : "Delete",
                                }
                            }}
                            columns={distributorUserColumns}
                            data={distributorUserInformations}
                            title=""
                            editable={{
                            onRowUpdate: (newData, oldData) =>
                                new Promise((resolve, reject) => {
                                    if((newData.distributor_email).match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)){
                                        resolve(this.props.updateDistributorUser(newData, oldData.distributor_email, distributorUserInformations))
                                    }else{
                                        toast.error("Please enter an valid email", {containerId: 'toastMsg'});
                                        reject();
                                    }
                                }),
                            onRowDelete: oldData =>
                                new Promise((resolve, reject) => {
                                    resolve(this.props.deleteDistributorUser(oldData, oldData.distributor_email, distributorUserInformations))
                                }),
                            }}
                        />
                    }
                </Paper>

            </div>
        )
    }
}

const mapStateToProps = state => {
    return{
        distributorState : state.distributor,
        sidebarState : state.sidebarState
    }
}
const mapDispatchToProps = dispatch => {
    return{
        getDistributorUser : () => {
            return dispatch(getDistributorUser())
        },
        updateDistributorUser : (rowData,email, distributorUserInformations) => {
            return dispatch(updateDistributorUser(rowData,email, distributorUserInformations))
        },
        deleteDistributorUser : (rowData, email, distributorUserInformations) => {
            return dispatch(deleteDistributorUser(rowData, email, distributorUserInformations))
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ListDistributor));